// @ts-nocheck
import * as React from "react";

const QuestionMarkCircleFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 16a1 1 0 1 1 1-1 1 1 0 0 1-1 1Zm1-5.16V14a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1 1.5 1.5 0 1 0-1.5-1.5 1 1 0 1 1-2 0 3.5 3.5 0 1 1 4.5 3.34Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(QuestionMarkCircleFill);
